import { enableProdMode, ErrorHandler, importProvidersFrom } from '@angular/core';
import { ErrorHandlerService } from './app/core/middleware/error-handler';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { InMemoryScrollingOptions, provideRouter, withComponentInputBinding, withInMemoryScrolling, withPreloading } from '@angular/router';
import { AppComponent } from './app/app.component';
import { APP_ROUTES } from './app/app.routing';
import { CoreModule } from './app/core/core.module';
import { AuthInterceptor } from './app/core/middleware/auth.interceptor';
import { ModulePreloadService } from './app/core/services/module-preload.service';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'top',
  anchorScrolling: 'enabled',
};

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(BrowserModule, CoreModule),
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(APP_ROUTES, withPreloading(ModulePreloadService), withInMemoryScrolling(scrollConfig), withComponentInputBinding()),
  ],
}).catch(err => console.error(err));
